import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WhyChooseUs = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <div className="page-head">
                            <h2 style={{ fontSize: '33px' }}>Why Choose Us</h2>
                            <div className="head-title">
                                <div className="hl-1"></div>
                                <div className="hl-2"></div>
                                <div className="hl-3"></div>
                            </div>
                            <p>Affordable Living. Unmatched Care. That’s the Younic Way.</p>
                        </div>

                        <div className="content-section">
                            <section className="content-section container mt-5">
                                <article>
                                    <h3 className='mb-3'>Hostel in Dhaka: Why Younic Home is the Perfect Place to Stay</h3>
                                    <p>
                                        Dhaka is a bustling, fast-moving city — a hub for students, job seekers, and young professionals from across the country. With this growing population comes the increasing need for affordable, safe, and comfortable accommodation. If you're searching for a hostel in Dhaka that truly feels like home, look no further than Younic Home.
                                    </p>

                                    <h4>What Makes Younic Home Different?</h4>
                                    <p>
                                        At Younic Home, we believe that a hostel shouldn’t just be a place to stay — it should be a place to live, grow, and feel secure. That’s why we’ve created an environment that’s clean, modern, and supportive.
                                    </p>

                                    <p>Here’s what you’ll love about staying at Younic Home:</p>
                                    <ul>
                                        <li><strong>Fully Furnished Rooms –</strong> Clean, well-maintained, and thoughtfully designed for maximum comfort</li>
                                        <li><strong>Three Daily Meals –</strong> Healthy, home-style meals served every day</li>
                                        <li><strong>24/7 Security –</strong> CCTV surveillance and staff to ensure your safety around the clock</li>
                                        <li><strong>Power Backup, Wi-Fi, and Laundry –</strong> Essential services included for a hassle-free experience</li>
                                        <li><strong>Prayer Spaces & Study Zones –</strong> We respect your spiritual and academic needs</li>
                                        <li><strong>Separate Branches for Male & Female Residents –</strong> Located in key areas like Uttara, Dhanmondi, and Ashulia</li>
                                    </ul>

                                    <h4>Affordable Living in the Heart of the City</h4>
                                    <p>
                                        Finding an affordable hostel in Dhaka that doesn’t compromise on quality can be challenging. At Younic Home, we offer rooms starting at just 349 BDT per day, which includes three meals and full access to all our facilities.
                                    </p>
                                    <p>
                                        Whether you're an SSC student in town for exams, a university student seeking a safe long-term stay, or a professional starting your career in the city — we have the right space for you.
                                    </p>
                                </article>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default WhyChooseUs;
